module.exports = __webpack_public_path__ + "img/02.9cc91d6d.png";